import { render } from "./deal-type.vue?vue&type=template&id=0a6a7a55"
import script from "./deal-type.vue?vue&type=script&lang=js"
export * from "./deal-type.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/html/appitoc/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__